/**
 * TypingIndicator — shown while the assistant's next turn is on its way: the same flipping
 * Fusion MSI star as the full-page loader, at chat size, with a "Thinking…" label so the
 * star reads as a wait rather than a decoration.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FusionLoader from 'components/common/FusionLoader';

function TypingIndicator({ size = 24 }) {
  const { t } = useTranslation('assistant');
  return (
    <Box role="status" aria-label={t('chat.thinking')} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <FusionLoader size={size} />
      <Typography variant="body2" color="text.secondary">
        {t('chat.thinking')}
      </Typography>
    </Box>
  );
}

export default TypingIndicator;
